module.exports = __webpack_public_path__ + "static/media/022.3be2a4a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/022.jpg
// module id = 319
// module chunks = 0